import { getBuildInfo, formatTaiwanTime } from '@/version';

export function Footer() {
  const buildInfo = getBuildInfo();
  const taiwanTime = formatTaiwanTime(buildInfo.buildTime);

  return (
    <footer className="mt-12 py-6 border-t border-gray-200 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-gray-600">
          {/* 版本資訊 | Version info */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="font-medium">版本 | Version:</span>
              <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded font-mono text-xs font-semibold">
                v{buildInfo.version}
              </span>
            </div>
            {buildInfo.commitHash && (
              <div className="flex items-center gap-2">
                <span className="font-medium">Commit:</span>
                <span className="font-mono text-xs text-gray-500">
                  {buildInfo.commitHash.slice(0, 7)}
                </span>
              </div>
            )}
          </div>

          {/* 建置時間 | Build time */}
          <div className="flex items-center gap-2">
            <span className="font-medium">更新時間 | Updated:</span>
            <span className="font-mono text-xs text-gray-700">
              {taiwanTime}
            </span>
          </div>
        </div>

        {/* 額外資訊 | Additional info */}
        <div className="mt-4 text-center text-xs text-gray-500">
          製造排程系統 POC Demo © 2026 | Manufacturing Scheduling System
        </div>
      </div>
    </footer>
  );
}
